import { APIMethod, fetchData } from "@client";

export async function addProjectCommentQuery(uuid, comment, mentions) {
  const data = {
    uuid,
    comment,
    notify: mentions?.length ? JSON.stringify(mentions) : undefined
  };
  return await fetchData("/project/comment", APIMethod.POST, { data });
}
